module.exports = __webpack_public_path__ + "static/media/android.6d23c371.png";